export default function initBsnValidator() {
    $.validator.unobtrusive.adapters.add("validbsn", [],
        function (options) {
            options.rules['validbsn'] = {};
            options.messages['validbsn'] = options.message;
        }
    );

    $.validator.addMethod("validbsn", function (value, element, param) {
        if (value.length !== 9) {
            return false;
        }
        let sum = 0;

        for (let index = 0; index < 8; index++) {
            sum += value[index] * (9 - index);
        }
        sum -= value[8];
        
        return sum % 11 === 0;
    })
}